import { Injectable } from '@angular/core';

@Injectable()
export class LocalSessionService {
  public get (): Storage {
    return sessionStorage;
  }
}
